<form [formGroup]="formGroup">
  <div
    class="flex flex-col justify-start md:flex-row md:justify-between w-full items-center">
    <div
      class="my-1 flex flex-col justify-start items-center w-full gap-2 md:flex-row">
      <!-- Date Picker -->
      <mat-form-field class="w-full md:w-4/12">
        <mat-label>Due</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="task_due_date" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="formGroup.get('task_due_date')?.hasError('required')">Due date is required</mat-error>
      </mat-form-field>

      <div
        class="flex flex-row items-center w-full md:w-8/12"
        [ngClass]="{
          'justify-end': ignoreTime,
          'justify-between': !ignoreTime,
        }">
        <!-- Time Picker -->
        <ng-container *ngIf="!ignoreTime" class="w-1/2">
            <mat-form-field
              class="w-full mt-0 md:-mt-5"
              [subscriptSizing]="'dynamic'">
              <mat-label>Time</mat-label>
              <input
                matInput
                type="time"
                formControlName="task_due_time"
                placeholder="Select time" />
            </mat-form-field>
        </ng-container>
        <!-- Checkbox -->
        <mat-checkbox
          formControlName="ignore_time"
          [ngClass]="
            ignoreTime
              ? 'md:justify-end sm:justify-start w-full'
              : 'justify-end w-1/2'
          "
          color="primary"
          class="mt-5 md:mt-0">
          Ignore Time
        </mat-checkbox>
      </div>
    </div>
  </div>
</form>
